import { DateTime } from 'luxon';
import { RetentionPolicy, RetentionRunResult } from '../RetentionPolicy';

interface ProjectRetentionProps {
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
  active?: boolean;
}

export function ProjectRetention(props: ProjectRetentionProps) {
  return (
    <RetentionPolicy
      {...props}
      endpoint="/api/project_retention/1"
      subject="Project"
      minimumMonths={0}
      runButtonLabel="Run project scrub"
      warning={(months, cutoff) =>
        `Project records are preserved. For projects whose Project Fair ended more than ${months} months ago (before ${cutoff}), executive sponsor, team, thanks, and video/Spark URLs are permanently cleared. Legacy projects without a fair end date use their creation date. Logo image content remains, but identifying filenames are replaced with project IDs.`
      }
      confirmation={(cutoff) => (
        <>
          <p>You are about to scrub projects whose Project Fair ended before {cutoff}. Legacy projects without a fair end date use their creation date.</p>
          <p>Project rows and their body of work remain. Titles, descriptions, tags, year, chapter, Project Fair association, and logo image content are preserved.</p>
          <p>These fields are cleared:</p>
          <ul>
            <li>Executive sponsor</li>
            <li>Team information</li>
            <li>Thanks section</li>
            <li>Video stream URL</li>
            <li>Video URL</li>
            <li>Spark URL</li>
          </ul>
          <p>Logo filenames are replaced with neutral project IDs; the image content is preserved.</p>
        </>
      )}
      formatRunSuccess={(result: RetentionRunResult) =>
        `Scrubbed ${result.purgedCount} projects and renamed ${result.renamedLogoCount ?? 0} logo files before ${DateTime.fromJSDate(new Date(result.cutoffDate)).toLocaleString(DateTime.DATE_FULL)}.`
      }
    />
  );
}
